module.exports = __webpack_public_path__ + "components/flag/static/square/pk-dd7738525a7e890769034ad9887d3cd5.svg";